const prop = 'accountName';

export const config = (labels) => ({
    id: `${prop}Column`,
    label: labels[prop],
    propName: 'accountName',
    sortBy: prop,
    width: 'minmax(var(--px-240), 2fr)'
});
